var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrowsing = function SvgBrowsing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M5.863 9.917v14.857h18.571v2.477H5.863c-2.476 0-2.476-2.477-2.476-2.477V9.917zm21.419-4.952H10.444c-1.164 0-2.105.867-2.105 1.919v13.495c0 1.065.941 1.92 2.105 1.92h16.838c1.164 0 2.105-.855 2.105-1.92V6.884c0-1.052-.941-1.92-2.105-1.92M10.815 7.44h6.19v7.429h-6.19zm16.096 12.381H10.814v-2.476h16.096zm0-4.952h-7.429v-2.477h7.429zm0-4.953h-7.429V7.441h7.429z"
  })));
};
export default SvgBrowsing;